export function isNextDay(today: Date, date: Date): boolean {
  return (
    date.getDate() - today.getDate() === 1 &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
}
